module.exports = __webpack_public_path__ + "static/assets/30369b87eed36dd399a127ae7c0ea1a4.png";